import script from "./NavItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=66445342&lang=scss"

const __exports__ = script;

export default __exports__